// extracted by mini-css-extract-plugin
export var divider = "_sg-0";
export var systemMessage = "_sg-1";
export var systemMessageWrapper = "_sg-2";